import api from './client'
import type { AuthUser } from '@/stores/auth'

export interface LoginRequest {
  username: string
  password: string
}

export interface LoginResponse {
  user: AuthUser
  token: string
}

export async function login(payload: LoginRequest): Promise<LoginResponse> {
  return api.post<LoginResponse>('/api/web-auth/login', payload, { skipAuthRedirect: true })
}

export async function logout(): Promise<void> {
  await api.post<void>('/api/web-auth/logout', undefined, { silent: true })
}

export async function checkAuth(): Promise<LoginResponse> {
  return api.get<LoginResponse>('/api/web-auth/check', { skipAuthRedirect: true })
}

// Auth status (configured? logged in? username? is_default flag for forced change-password banner)
export interface AuthStatus {
  configured: boolean
  logged_in: boolean
  username?: string
  is_default?: boolean
}

export async function getAuthStatus(): Promise<AuthStatus> {
  return api.get<AuthStatus>('/api/web-auth/status', { skipAuthRedirect: true })
}

// Setup (initial admin)
export interface SetupRequest {
  username: string
  password: string
}

export async function setupAuth(payload: SetupRequest): Promise<{ ok: boolean; username: string }> {
  return api.post<{ ok: boolean; username: string }>('/api/web-auth/setup', payload, {
    skipAuthRedirect: true,
  })
}

// Change password — backend takes {old, new, new_confirm}
export interface ChangePasswordRequest {
  old: string
  new: string
  new_confirm: string
}

export async function changePassword(payload: ChangePasswordRequest): Promise<void> {
  return api.post<void>('/api/web-auth/change-password', payload)
}

// v3.13.92: 个人资料 (昵称) + 头像。
export interface ProfileResponse {
  ok: boolean
  user: AuthUser
}

export async function updateProfile(nickname: string): Promise<ProfileResponse> {
  return api.post<ProfileResponse>('/api/web-auth/profile', { nickname })
}

export async function uploadAvatar(file: File): Promise<{ ok: boolean; avatarV: number }> {
  const form = new FormData()
  form.append('file', file)
  return api.post<{ ok: boolean; avatarV: number }>('/api/web-auth/avatar', form)
}

export async function removeAvatar(): Promise<{ ok: boolean; avatarV: number }> {
  return api.delete<{ ok: boolean; avatarV: number }>('/api/web-auth/avatar')
}

/** 头像 URL (v 版本戳做 cache-bust); 无头像返回 null。 */
export function avatarUrl(avatarV?: number): string | null {
  if (!avatarV) return null
  return `/api/web-auth/avatar?v=${avatarV}`
}
